module.exports = __webpack_public_path__ + "static/media/Sara_canvas_6.9c6f4ea3.png";